<template>
  <skeleton v-if="isLoadingArticle"></skeleton>
  <div v-else v-html="articleHtml"></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SitePageArticle",
  computed: {
    ...mapGetters({
      isLoadingArticle: "getLoadingArticleState",
      articleHtml: "getArticleHtml"
    }),
  }
};
</script>
